import ErrorIcon from "@mui/icons-material/HighlightOff";
import { Box, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";

import Info from "./info";

function flattenData(data: ResponseObjectsError[]): FlattenedData {
  const flattened: FlattenedData = {};

  for (const item of data) {
    const key = item.name;
    const value = item.userMessage;

    flattened[key] = value;
  }

  return flattened;
}

interface LinkCodeHasExpiredProps {
  info?: ResponseObjectsError[];
}

function LinkCodeHasExpired({
  info,
}: LinkCodeHasExpiredProps): React.JSX.Element {
  const { t } = useTranslation();
  const processedData = flattenData(info || []);
  return (
    <Stack sx={{ width: "100%", p: { xs: 2, md: "2%" } }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          width: "100%",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <Stack
          alignItems="flex-start"
          justifyContent="flex-start"
          sx={{ width: { xs: "100%", md: "50%" }, order: 1 }}
        >
          {info && info.length > 0 ? (
            <Info
              authorName={processedData.signatureBatchAuthor || ""}
              createdAt={processedData.createdAt || ""}
              id={processedData.signatureBatchId || ""}
              status={processedData.status || ""}
              title={processedData.title || ""}
              updatedAt={processedData.expirationDate || ""}
            />
          ) : null}
          <Stack alignItems="center" direction="row" spacing={2} sx={{ mt: 4 }}>
            <ErrorIcon color="error" />
            <Typography
              sx={{ fontWeight: "500", fontSize: 20, color: "error.main" }}
              variant="h6"
            >
              {t("sign.expired")}
            </Typography>
          </Stack>
        </Stack>

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            order: 2,
          }}
        >
          <img
            alt="logo"
            src="/assets/timeExpired.svg"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "290px",
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
}

export default LinkCodeHasExpired;
